import { actionTypes } from "./actions";

const initialState = {
    alt: 0,
    approxTimeLeft: 0,
    assigned: 0,
    assignTimes: [],
    isComplete: false,
    isStarted: false,
    lastAssignTime: "",
    required: 0,
};

export default function (state = { ...initialState }, action) {
    switch (action.type) {
        case actionTypes.AUDIT_COMPLETION_CLEAR: {
            return initialState;
        }
        case actionTypes.AUDIT_COMPLETION_INIT: {
            return { ...initialState };
        }
        case actionTypes.AUDIT_COMPLETION_SET: {
            const { auditCompletion } = action.payload;
            return { ...state, ...auditCompletion };
        }
        default: {
            return state;
        }
    }
}
